import React from "react";
import { Box, Select, rem } from "@mantine/core";
import useStyles from "./style";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";

const NoteTypeComp = ({
  edit,
  note,
  noteType,
  setNoteType,
  className,
  setEssentialSupportToggle,
  setMessages,
  setAiAssistantCardOpened,
  handleRecordingCancel,
  setShowAiButtons,
  
}) => {
  const { classes } = useStyles();
  const { allNotesTypes, } =
    useSelector((state) => state?.note);
  const icon = (
    <DropDownArrowSvg color={true} style={{ width: rem(1), height: rem(1) }} />
  );

  const form = useForm({
    initialValues: {
      selected: "",
    },
    validate: {
      selected: (value) => (value ? null : "Please select type"),
    },
  });

  return (
    <Box className={`${classes.noteTypeParent} ${className ? className : ""}`}>

      <Select
        size="sm"
        searchable
        id="note-type"
        label="Note Type"
        placeholder="Select an option"
        className={`${classes.typeSelector}`}
        value={noteType?.id}
        rightSection={icon}
        disabled={edit || note}
        data={
          allNotesTypes?.ntypes?.map((value) => ({
            label: value?.name,
            value: value?.id,
          })) || []
        }
        onChange={(selectedValue) => {
          const selectedNoteType = allNotesTypes?.ntypes?.find(
            (nt) => nt.id === selectedValue
          );
          setNoteType(selectedNoteType);
          setEssentialSupportToggle("no");
          form.setFieldValue("selected", selectedValue);
          setAiAssistantCardOpened(false);
          setMessages([]);
          handleRecordingCancel();
          setShowAiButtons(false);
        }}
      />
    </Box>
  );
};

export default NoteTypeComp;
